import { useShowDebugInfo } from "../hooks/configuration";
import { debugTagPalette } from "../theme/palettes";

const hashCode = (str: string): number =>
    Array.from(str).reduce((hash, char) => ((hash << 5) - hash + char.charCodeAt(0)) | 0, 0);

// Use the hash to pick a color from the palette
const getColorForTag = (tag: string): string => debugTagPalette.tags[Math.abs(hashCode(tag)) % debugTagPalette.tags.length];

export const PrimeDebugLog = (tag: string, ...args: unknown[]) => {
    if (useShowDebugInfo()) {
        const bgColor = getColorForTag(tag);
        const tagStyle = `color: ${debugTagPalette.text}; background-color: ${bgColor}; padding: 2px 4px; border-radius: 4px;`;
        console.log(`%c${tag}%c `, tagStyle, "", ...args);
    }
};
